// *** OTHER GLOBALS ***

import { AppVersionInfo, getDefaultVersionInfo } from "./store/appVersion/appVersionTypes";
import { newGuid } from "./util/math";
import { getFilenameSafeTimestamp } from "./util/string-convert";

/** Default app name of MVision Configuration -- NOTE: use translation pack name ('appTitle') via i18next in UI instead of this! */
export const DEFAULT_APP_NAME = 'MVision Configuration';
export const APP_NAME_SHORT = 'mvconfigui';
export const getDefaultAppName = () => DEFAULT_APP_NAME;

export const WORKSPACE_NAME = 'Workspace+';

/** The "version" of the app that's displayed for the user. This needs to be set MANUALLY for each release! */
export const DISPLAY_VERSION = '1.4.0';

/** Returns a uniform 'appVersion' string to be used with API calls.
 * The string is in the format of "appName/displayVersion/commitHash".
 * E.g.: "MVision Configuration/1.4.0/1234567890abcdef1234567890abcdef12345678".
 * A default dummy app version is used if appVersion is not given or is undefined.
 */
export function getAppVersionHeader(appVersion?: AppVersionInfo | undefined): string {
    const version = appVersion || getDefaultVersionInfo();
    return `${getDefaultAppName()}/${DISPLAY_VERSION}/${version.commit}`;
}

/// *** APP REGISTRATIONS, AUTHORIZATIONS ***

export const MVAPI_DEFAULT = 'MVAPI_CLINICAL';

export const MVISION_AUTHORITY = 'https://login.microsoftonline.com/mvision.ai';

export const mvapiClinicalAppRegistrationApplicationClientId = '49dd79c5-077f-4fa1-a055-4752e20025bd';
// export const mvdapiprodUrl = 'https://mvd-api-westeurope.azurewebsites.net';

export const LOGGED_OUT_URI = '/logged-out';

export const HOME_PAGE_REDIRECT_URL = '/#/';

// *** SESSION ID ***

/** Session ID is used to identify this particular web client session in API calls. */
let sessionId: string;

/** (Re-)generates and sets a new session ID. */
export function generateNewSessionId() {
    sessionId = `${APP_NAME_SHORT}-${getFilenameSafeTimestamp()}-${newGuid()}`.substring(0, 64);
    console.info(`Session ID: ${sessionId}`);
}

/** Returns the current session ID. */
export function getSessionId(): string {
    if (!sessionId) {
        generateNewSessionId();
    }

    return sessionId;
}

// *** CLIENT LISTS ***

/** Daemon client names start with this prefix */
export const daemonPrefix = 'mvdaemon-';
